/** True when value looks like a MongoDB ObjectId (24 hex chars). */
export const isMongoObjectId = (value) =>
  typeof value === "string" && /^[a-f\d]{24}$/i.test(value.trim());
